export const refresh = {
  data () {
    return {
      refresh_active: true,
      refresh_time: 15000,
      refresh_method: 'loadData'
    }
  },
  methods: {
    refreshData () {
      if (this.refresh_active) {
        this.interval = setInterval(this[this.refresh_method], this.refresh_time)
      }
    },
    refreshStop () {
      clearInterval(this.interval)
    }
  },
  mounted () {
    this.refreshData()
  },
  beforeDestroy () {
    this.refreshStop()
  }
}



// WEBPACK FOOTER //
// ./src/js/mixins/refresh.js